import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);


class VideoSequenceStage {
  constructor(options = {}) {
    this.element = options.element;
  }

  init() {
    this.buildSequence();
  }

  buildSequence() {
    const currentFrame = index => (`/images/video-sequence/map-image-${(index).toString()}.webp`);
    const placeholder = document.querySelector('.video-sequence-stage__video-placeholder');
    const frameCount = 60;
    const images = [];
    const frames = {
      frame: 0,
    };

    let firstLoaded = false;

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);

      // eslint-disable-next-line no-loop-func
      img.onload = () => {
        if (!firstLoaded) {

          /**
           * Render first image and remove loading skeleton after all is loaded, needs to be added extra
           *
           * @type {HTMLElement}
           */
          this.render(img);
          firstLoaded = true;
        }
      };

      images.push(img);

      window.addEventListener('load', () => {
        if (images.length === frameCount) {
          placeholder.classList.remove('show-placeholder');
        }
      });
    }

    gsap.to(frames, {
      frame: frameCount - 1,
      snap: 'frame',
      ease: 'none',
      scrollTrigger: {
        trigger: '#video-canvas-stage-canvas',
        start: '0',
        end: '900',
        scrub: 0.5,
      },
      onUpdate: () => this.render(images[frames.frame]),
    });
  }

  render(img) {
    const canvas = document.getElementById('video-canvas-stage-canvas');
    const context = canvas.getContext('2d');
    canvas.width = 1920;
    canvas.height = 1080;
    context.clearRect(0, 0, canvas.width, canvas.height);

    const scale = Math.max((canvas.width / img.width), (canvas.height / img.height));
    /* eslint-disable */
    const x = (canvas.width / 2) - (img.width / 2) * scale;
    const y = (canvas.height / 2) - (img.height / 2) * scale;
    /* eslint-enable */

    context.drawImage(img, x, y, img.width * scale, img.height * scale);
  }
}

export default VideoSequenceStage;
